import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "categories-suggestion" }
const _hoisted_2 = {
  key: 0,
  class: "m-tag-list"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 1,
  class: "categories-suggestion_loading m-tag-list"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VJoyLabel = _resolveComponent("VJoyLabel")!
  const _component_VJoyIcon = _resolveComponent("VJoyIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_VJoyLabel, null, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$msg('customer.brief.form.freelancer.profile.categories.suggestion.title')), 1)
      ]),
      _: 1
    }),
    (!_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (category) => {
            return (_openBlock(), _createElementBlock("button", {
              key: category.categoryId,
              class: _normalizeClass(["m-tag", {'m-tag_secondary': category.categoryId !== _ctx.selectedCategory}]),
              onClick: _withModifiers(($event: any) => (_ctx.handleSelectCategory(category)), ["prevent"])
            }, [
              (category.categoryId === _ctx.selectedCategory)
                ? (_openBlock(), _createBlock(_component_VJoyIcon, {
                    key: 0,
                    name: "check",
                    color: "white"
                  }))
                : _createCommentVNode("", true),
              _createTextVNode(" " + _toDisplayString(category.label), 1)
            ], 10, _hoisted_3))
          }), 128))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (skeletonTag) => {
            return _createElementVNode("div", {
              key: skeletonTag,
              class: "m-tag m-tag_secondary"
            })
          }), 64))
        ]))
  ]))
}